import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidators {
  static containsUpperCaseCharacter(
    control: AbstractControl<any, any>
  ): ValidationErrors | null {
    const upperCaseRex = /[A-Z]+/g;

    if (control.value) {
      return upperCaseRex.test(control.value) ? null : { uppercase: true };
    } else {
      return null;
    }
  }

  static containsNumericCharacter(
    control: AbstractControl<any, any>
  ): ValidationErrors | null {
    const numericRex = /[0-9]+/g;

    if (control.value) {
      return numericRex.test(control.value) ? null : { numeric: true };
    } else {
      return null;
    }
  }
  static containsLowerCaseCharacter(
    control: AbstractControl
  ): ValidationErrors | null {
    const loweerCaseRex = /[a-z]+/g;

    if (control.value) {
      return loweerCaseRex.test(control.value) ? null : { lowercase: true };
    } else {
      return null;
    }
  }

  static containsSpeicalCharacter(
    control: AbstractControl
  ): ValidationErrors | null {
    const specialCharacterRex = /[!@#$%^&*]+/g;

    if (control.value) {
      return specialCharacterRex.test(control.value)
        ? null
        : { specialcharacter: true };
    } else {
      return null;
    }
  }

  static matchWith(baseControlName: string): ValidatorFn {
    return function (control: AbstractControl) {
      const baseControl = control.parent?.get(baseControlName);

      if (control.value !== baseControl?.value) {
        return { match: true };
      } else {
        return null;
      }
    };
  }

  static passwordsMatch(): ValidatorFn {
    return (fg: AbstractControl) => {
      const passwordControl = fg.get('password');
      const repeatPasswordControl = fg.get('passwordRepeat');

      if (passwordControl?.value !== repeatPasswordControl?.value) {
        return { match: true };
      } else {
        return null;
      }
    };
  }
}
